'use strict';

const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = withRenderedMain(BaseView.extend({
    cons: {
        open: 'open',
    },
    selectors: {
        container: '.psd2_communication_popup_container',
    },
    events: {
        'tap .closeBtn': 'close',
    },
    open() {
        const $container = this.$el.find(this.selectors.container);
        $container.toggleClass(this.cons.open, true);
        trackingUtils.trackEvent('payment_details_psd2_popup', 'psd2_pay_popup_shown');
    },
    close() {
        const $container = this.$el.find(this.selectors.container);
        $container.toggleClass(this.cons.open, false);
        trackingUtils.trackEvent('payment_details_psd2_popup', 'psd2_pay_popup_agree_click');
    },
}));
